import { render, staticRenderFns } from "./DashboardGroups.vue?vue&type=template&id=2b3c18f3&scoped=true&"
import script from "./DashboardGroups.vue?vue&type=script&lang=js&"
export * from "./DashboardGroups.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGroups.vue?vue&type=style&index=0&id=2b3c18f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c18f3",
  null
  
)

export default component.exports